module.exports = __webpack_public_path__ + "img/statistics.5d9093cb.svg";